module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-nissan.5ad83898.png";